import React from "react";
import { PageShell, EditableSection } from "./PageShell";

const SECTIONS = [
  { heading: "What we’ve done", body: "• All interactive elements are keyboard-navigable with visible focus states\n\n• Text/background contrast tested at 4.5:1 minimum\n\n• Semantic HTML throughout — headings, landmarks, ARIA where necessary\n\n• Every image has descriptive alt text; decorative visuals are marked as such\n\n• Motion respects `prefers-reduced-motion` at the system level\n\n• Forms use associated labels and inline error messaging" },
  { heading: "Known limitations", body: "Some third-party embeds (payment providers, courier tracking iframes) are outside our direct control. Where we identify a gap, we work with the provider to close it." },
  { heading: "Report a barrier", body: "Encountered something difficult? Please email access@scentodore.com with the page URL and a short description. We aim to acknowledge within 2 business days and remedy within 30." },
];

export default function AccessibilityPage() {
  return (
    <PageShell
      slug="accessibility"
      testid="accessibility"
      eyebrow="Commitment"
      title="Accessibility Statement"
      intro="Scentodore is committed to making our site usable for everyone. We follow the WCAG 2.2 AA standard and audit continuously."
    >
      <EditableSection slug="accessibility" sectionKey="clauses" fallback={SECTIONS} />
    </PageShell>
  );
}
